/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import authService from "@/services/authService";
export default {
  getIdToken: state => {
    if (state.idToken) {
      return state.idToken;
    } else {
      return authService.getIdToken();
    }
  },
  isUpdatingToken: state => {
    return state.refreshTokenRequestSymbols.length > 0;
  },

  accountId: state => {
    return state.accountId;
  },

  getEnterpriseId: state => {
    return state.user.id;
  },

  getRgExternalToken: state => {
    return state.rgExternalToken;
  },

  getRgGroupId: state => {
    return state.rgGroupId;
  },
};
